"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeContext = void 0;
const react_1 = require("react");
const theme_1 = require("../../utils/theme");
exports.ThemeContext = (0, react_1.createContext)({ theme: theme_1.defaultDesignTheme });
